import React, { useState } from 'react';
import './style.scss';
import cx from 'classnames';

interface FeatureTabState {
  selectedItem: number | null;
}

export default class FeatureTab extends React.Component<any, FeatureTabState> {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: null,
    };
  }

  showOption(index) {
    this.setState({ selectedItem: index });
  }

  render() {
    const { options } = this.props;
    const { selectedItem } = this.state;

    return (
      <div className="options-container">
        {options.map((option, index) => (
          <div
            key={index}
            className={cx('option', option.className, {
              selected: selectedItem === index,
            })}
            onClick={() => this.showOption(index)}
            id={option.id}
          >
            <div className="options-header">
              {option.iconBack && (
                <div className="icon back" onClick={() => option.onBack()}>
                  <i className={`fa ${option.iconBack}`} />
                </div>
              )}

              <div className={cx('icon', { 'border-back': option.iconBack })}>
                <i className={`fa ${option.icon}`} />
              </div>

              <div className="title">
                <p>{option.title}</p>
              </div>

              {option.subtitle && (
                <div className="subtitle">
                  <p>{option.subtitle}</p>
                </div>
              )}
            </div>

            <div className="content-tab">
              {React.isValidElement(option.content)
                ? option.content
                : option.content()}
            </div>
          </div>
        ))}
      </div>
    );
  }
}
